"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _ = require("./");

var _luxon = require("luxon");

class Ergonar {
  static thaw(ergonarObj) {
    if (ergonarObj == null) return null;
    const ergonar = new Ergonar();
    if (ergonarObj.id != null) ergonar.setId(ergonarObj.id);
    if (ergonarObj.name != null) ergonar.setName(ergonarObj.name);
    if (ergonarObj.zoomWebinarId != null) ergonar.setZoomWebinarId(ergonarObj.zoomWebinarId);
    if (ergonarObj.estimatedDuration != null) ergonar.setEstimatedDuration(ergonarObj.estimatedDuration);
    if (ergonarObj.dateTime != null) ergonar.setDateTime(_luxon.DateTime.fromISO(ergonarObj.dateTime));
    if (ergonarObj.videoUrl != null) ergonar.setVideoUrl(ergonarObj.videoUrl);
    if (ergonarObj.purchasers != null) ergonar.setPurchasers(_.Person.thawList(ergonarObj.purchasers));
    if (ergonarObj.segments != null) ergonar.setSegments(_.ErgoAlgoSegment.thawList(ergonarObj.segments));
    if (ergonarObj.isScheduled != null) ergonar.setIsScheduled(ergonarObj.isScheduled);
    if (ergonarObj.price != null) ergonar.setPrice(ergonarObj.price);
    if (ergonarObj.displayImageUrl != null) ergonar.setDisplayImageUrl(ergonarObj.displayImageUrl);
    if (ergonarObj.isActive != null) ergonar.setIsActive(ergonarObj.isActive);
    if (ergonarObj.notes != null) ergonar.setNotes(ergonarObj.notes);
    if (ergonarObj.description != null) ergonar.setDescription(ergonarObj.description);
    if (ergonarObj.hasAccess != null) ergonar.setHasAccess(ergonarObj.hasAccess);
    if (ergonarObj.hasRSVP != null) ergonar.setHasRSVP(ergonarObj.hasRSVP);
    if (ergonarObj.type != null) ergonar.setType(ergonarObj.type);
    return ergonar;
  }

  static thawList(ergonarObjList) {
    if (ergonarObjList == null) return [];
    var ergonars = [];

    for (var i = 0; i < ergonarObjList.length; i++) {
      ergonars.push(Ergonar.thaw(ergonarObjList[i]));
    }

    return ergonars;
  }

  static freeze(ergonar) {
    if (ergonar == null) return null;
    var ergonarObj = {};
    if (ergonar.getId() != null) ergonarObj.id = ergonar.getId();
    if (ergonar.getName() != null) ergonarObj.name = ergonar.getName();
    if (ergonar.getZoomWebinarId() != null) ergonarObj.zoomWebinarId = ergonar.getZoomWebinarId();
    if (ergonar.getEstimatedDuration() != null) ergonarObj.estimatedDuration = ergonar.getEstimatedDuration();
    if (ergonar.getDateTime() != null) ergonarObj.dateTime = ergonar.getDateTime();
    if (ergonar.getVideoUrl() != null) ergonarObj.videoUrl = ergonar.getVideoUrl();
    if (ergonar.getPurchasers() != null) ergonarObj.purchasers = _.Person.freezeList(ergonar.getPurchasers());
    if (ergonar.getSegments() != null) ergonarObj.segments = _.ErgoAlgoSegment.freezeList(ergonar.getSegments());
    if (ergonar.getIsScheduled() != null) ergonarObj.isScheduled = ergonar.getIsScheduled();
    if (ergonar.getPrice() != null) ergonarObj.price = ergonar.getPrice();
    if (ergonar.getDisplayImageUrl() != null) ergonarObj.displayImageUrl = ergonar.getDisplayImageUrl();
    if (ergonar.getIsActive() != null) ergonarObj.isActive = ergonar.getIsActive();
    if (ergonar.getNotes() != null) ergonarObj.notes = ergonar.getNotes();
    if (ergonar.getDescription() != null) ergonarObj.description = ergonar.getDescription();
    if (ergonar.getHasAccess() != null) ergonarObj.hasAccess = ergonar.getHasAccess();
    if (ergonar.getHasRSVP() != null) ergonarObj.hasRSVP = ergonar.getHasRSVP();
    if (ergonar.getType() != null) ergonarObj.type = ergonar.getType();
    return ergonarObj;
  }

  static freezeList(ergonars) {
    if (ergonars == null) return [];
    var ergonarObjList = [];

    for (var i = 0; i < ergonars.length; i++) {
      ergonarObjList.push(Ergonar.freeze(ergonars[i]));
    }

    return ergonarObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setZoomWebinarId(null);
    this.setEstimatedDuration(null);
    this.setDateTime(null);
    this.setVideoUrl(null);
    this.setPurchasers(null);
    this.setSegments(null);
    this.setIsScheduled(null);
    this.setPrice(null);
    this.setDisplayImageUrl(null);
    this.setIsActive(null);
    this.setNotes(null);
    this.setDescription(null);
    this.setHasAccess(null);
    this.setHasRSVP(null);
    this.setType(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setZoomWebinarId(zoomWebinarId) {
    this.zoomWebinarId = zoomWebinarId;
  }

  setEstimatedDuration(estimatedDuration) {
    this.estimatedDuration = estimatedDuration;
  }

  setDateTime(dateTime) {
    this.dateTime = dateTime;
  }

  setVideoUrl(videoUrl) {
    this.videoUrl = videoUrl;
  }

  setPurchasers(purchasers) {
    this.purchasers = purchasers;
  }

  setSegments(segments) {
    this.segments = segments;
  }

  setIsScheduled(isScheduled) {
    this.isScheduled = isScheduled;
  }

  setPrice(price) {
    this.price = price;
  }

  setDisplayImageUrl(displayImageUrl) {
    this.displayImageUrl = displayImageUrl;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setDescription(description) {
    this.description = description;
  }

  setHasAccess(hasAccess) {
    this.hasAccess = hasAccess;
  }

  setHasRSVP(hasRSVP) {
    this.hasRSVP = hasRSVP;
  }

  setType(type) {
    this.type = type;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getZoomWebinarId() {
    return this.zoomWebinarId;
  }

  getEstimatedDuration() {
    return this.estimatedDuration;
  }

  getDateTime() {
    return this.dateTime;
  }

  getVideoUrl() {
    return this.videoUrl;
  }

  getPurchasers() {
    return this.purchasers;
  }

  getSegments() {
    return this.segments;
  }

  getIsScheduled() {
    return this.isScheduled;
  }

  getPrice() {
    return this.price;
  }

  getDisplayImageUrl() {
    return this.displayImageUrl;
  }

  getIsActive() {
    return this.isActive;
  }

  getNotes() {
    return this.notes;
  }

  getDescription() {
    return this.description;
  }

  getHasAccess() {
    return this.hasAccess;
  }

  getHasRSVP() {
    return this.hasRSVP;
  }

  getType() {
    return this.type;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  className() {
    return 'Ergonar';
  }

}

exports.default = Ergonar;